module.exports = __webpack_public_path__ + "static/lights31-2f87bafbc8c139e0f54cf11c4c2f6eab.jpg";